<template>
  <div class="panelNagusia">
    <div class="ui breadcrumb">
      <a class="section" v-on:click="goTo('/dashboard')">Home</a>
      <i class="right angle icon divider"></i>
      <a class="active section" v-on:click="goTo('/inventory')">Inventario y Actuaciones</a>
      <i class="right angle icon divider"></i>
      <a class="active section">Reservas</a>
    </div>

    <h1 class="ui header">
      <i class="icon archive"></i>
      <div class="content">Reservas de columnas</div>
    </h1>

    <button class="ui basic button rightButton" @click="newReservationConfirm">
      <i class="add icon"></i>Nueva Reserva
    </button>

    <div class="ui stackable">
      <div v-if="(rows.length == 0)" class="ui active centered inline loader"></div>
      <div v-else class="row">
        <div class="column">
          <h4 class="ui dividing header">Reservas</h4>
          <vue-good-table ref="table" :columns="columns" :rows="rows" :line-numbers="true" :sort-options="{
            enabled: true,
            type: 'name asc'
          }" @on-row-click="columnReservationInfo" styleClass="verticalAlignMiddle vgt-table striped bordered">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'delete' && props.row.isOwner"
                @click.stop="deleteColumnReservationConfirm(props.row)" class="delete-icon-cell">
                <i class="trash alternate outline icon large"></i>
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
import { userNotification } from '@/tools/Utils'
export default {
  name: 'columnBookingList',
  data() {
    return {
      rows: [],
      columns: [
        {
          label: 'Reserva',
          field: 'name',
          filterOptions: {
            placeholder: 'Reserva',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Propietario',
          field: 'administrator_name',
          filterOptions: {
            placeholder: 'Propietario',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Nº de columnas',
          field: 'n_columns',
        },
        {
          label: '',
          field: 'delete',
          type: 'text',
        },
      ],
    }
  },

  created() {
    const role = JSON.parse(localStorage.admin).role;
    if (role === 'master' || role === 'admin') {
      this.getColumnsReservations()
    } else {
      this.$router.replace('/inventory')
    }
  },

  methods: {
    getColumnsReservations() {
      hapiickApi().post('/v1/reservations', {
        admin_id: JSON.parse(localStorage.admin).id,
      })
        .then((response) => this.updateTable(response.data.column_reservations))
        .catch((error) => console.log(`Error getColumnsReservations: ${error}`))
    },

    updateTable(reservations) {
      this.rows = reservations.map(a => ({
        ...a.ColumnReservation,
        'administrator_name': a.Administrator.name,
        'n_columns': a.StockProduct.length,
        'isOwner': (JSON.parse(localStorage.admin).id === a.ColumnReservation.administrator_id)
      }));

      if (this.rows.length === 0) {
        this.rows.push({ 'name': 'no hay reservas que mostrar' })
      }
    },

    newReservationConfirm() {
      this.$swal.fire({
        title: "Indica un nombre para tu nueva reserva",
        input: "text",
        focusConfirm: false,
        showCancelButton: true,
        preConfirm: async (name) => {
          if (!name) {
            this.$swal.showValidationMessage("Debes dar un nombre a tu nueva reserva")
            return
          } else if (this.rows.some(a => a.name === name && a.administrator_id === JSON.parse(localStorage.admin).id)) {
            this.$swal.showValidationMessage('Ya tienes una reserva con este nombre.')
            return
          }
        }
      }).then((result) => {
        if (result.value) {
          this.newReservation(result.value)
        }
      }).catch((error) => console.log(`Error newReservationConfirm: ${error}`))
    },

    newReservation(name) {
      this.rows = []
      hapiickApi().post('/v1/reservations/add', {
        admin_id: JSON.parse(localStorage.admin).id,
        column_reservation_name: name
      }).then((response) => {
        if (response.data.status === 'OK') {
          userNotification('success', 'La reserva se ha creado correctamente', '', 2500)
          this.goTo('/inventory/column/reservation/info/' + response.data.column_reservation_id)
        } else {
          userNotification('error', `No se ha podido crear la reserva ${name}`, '', 0)
        }
      }).catch(error => userNotification('error', `No se ha podido crear la reserva ${name}`, error, 0))
    },

    deleteColumnReservationConfirm(row) {
      this.$swal.fire({
        type: 'question',
        title: `¿Quieres eliminar la reserva ${row.name}?`,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.value) {
          this.deleteColumnReservation(row.id)
        }
      }).catch((error) => console.log(`Error deleteColumnReservationConfirm: ${error}`))
    },

    deleteColumnReservation(column_reservation_id) {
      this.rows = []
      hapiickApi().post('/v1/reservations/delete', {
        admin_id: JSON.parse(localStorage.admin).id,
        column_reservation_id: column_reservation_id
      })
        .then((response) => {
          this.getColumnsReservations()
          if (response.data.status === 'OK') {
            userNotification('success', 'La reserva ha sido eliminada', '', 2500)
          } else {
            userNotification('error', 'No se ha podido eliminar la reserva', '', 0)
          }
        })
        .catch(error => this.userNotification('error', 'No se ha podido eliminar la reserva', error, 0))
    },

    columnReservationInfo(params) {
      let routeData = this.$router.resolve('/inventory/column/reservation/info/' + params.row.id)
      window.open(routeData.href, '_blank')
    },

    goTo(where) {
      this.$router.push(where)
    }
  },
}
</script>

<style scope>
.delete-icon-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.verticalAlignMiddle td,
th {
  vertical-align: middle !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Inventory/columnBookingList.vue